const ss360ExecuteSearch = (inputValue) => {
  $.ajax({
    url: 'https://global.sitesearch360.com/sites/suggest',
    type: 'GET',
    data: {
      site: 'americandiscountvacations.com',
      limit: 6,
      maxQuerySuggestions: 3,
      query: inputValue
    },
    success: function (response) {
      if (response && Object.keys(response.suggests).length <= 0) {
        $('#unibox-suggest-box').removeClass('unibox--active');
        return;
      }
      let results = '';
      if (response.suggests.ss360QuerySuggestions) {
        results += `<section class="unibox-n-section">
          <h2 class="unibox__suggest-heading">Suggestions</h2>
          ${response.suggests.ss360QuerySuggestions
            .map((suggestion) => {
              const suggestionName = suggestion.name.replace(inputValue, `<span class="unibox__highlight">${inputValue}</span>`);
              return `<div class="unibox__selectable" aria-selected="false" role="option">
                <div class="unibox__content-container">
                  <span class="unibox__search-content">${suggestionName}</span>
                </div>
                <div class="unibox__ca" role="presentation"></div>
              </div>`;
            })
            .join('')}
          </section>`;
        delete response.suggests.ss360QuerySuggestions;
      }

      results += Object.entries(response.suggests)
        .map((entry) => {
          const key = entry[0];
          const suggestions = entry[1];
          return `<section class="unibox-n-section">
            ${key !== '_' ? `<h2 class="unibox__suggest-heading">${key}</h2>` : ''}
            ${suggestions
              .map(
                (suggestion) => `<a
                  class="unibox__selectable" aria-selected="false" role="option"
                  href="${suggestion.link}"
                  title="${suggestion.name}"
                >
                  <div class="unibox__content-container">
                    <span class="unibox__search-content unibox__search-content--link">${suggestion.name}</span>
                  </div>
                  <div class="unibox__ca" role="presentation"></div>
                </a>`
              )
              .join('')}
        </section>`;
        })
        .join('');

      $('#unibox-suggest-box').html(results);
      $('#unibox-suggest-box').addClass('unibox--active');
    }
  });
};

const populatePopularSearches = () => {
  const popularSearches = window.ss360Config.suggestions.emptyQuerySuggestions.suggests['Popular Searches'];
  $('#unibox-suggest-box').html(`<section
          class="unibox-n-section unibox__cluster unibox__cluster--popular_searches unibox__cluster--4-entries unibox__cluster--no-img"
          aria-labelledby="unibox-suggest-cluster-heading-popular_searches"
        >
        <h2 class="unibox__suggest-heading" id="unibox-suggest-cluster-heading-popular_searches">Popular Searches</h2>
        ${popularSearches
          .map(
            (popularSearch) => `<a
              class="unibox__selectable" aria-selected="false" role="option"
              href="${popularSearch.link}"
              title="${popularSearch.name}"
            >
            <div class="unibox__content-container">
              <span
                class="unibox__selectable unibox__search-content unibox__search-content--link"
                >${popularSearch.name}</span>
            </div>
            <div class="unibox__ca" role="presentation"></div>
          </a>`
          )
          .join('')}
      </section>`);
  $('#unibox-suggest-box').addClass('unibox--active');
};

const ss360SnakeCase = (string) => {
  return string
    .replace(/\W+/g, ' ')
    .split(/ |\B(?=[A-Z])/)
    .map((word) => word.toLowerCase())
    .join('_');
};
const openSs360Modal = () => {
  $('body').addClass('ss360-modal-on');
  $('.ss360-modal-body-wrapper').show();
  $('.ss360-layer').show();
};
const closeSs360Modal = () => {
  $('body').removeClass('ss360-modal-on');
  $('.ss360-modal-body-wrapper').hide();
  $('.ss360-layer').hide();
};

const ss360CustomSearch = (searchValue) => {
  $('#ss360-suggest-results').html('Loading...');
  $.ajax({
    url: 'https://global.sitesearch360.com/sites',
    type: 'GET',
    data: {
      site: 'americandiscountvacations.com',
      timeToAction: Date.now(),
      includeContent: true,
      limit: 5,
      limitPerGroup: true,
      highlightQueryTerms: true,
      offset: 0,
      query: searchValue,
      kvtable: false,
      complexFilterFormat: true
    },
    success: function (response) {
      $('.ss360-nav__menu').html(
        Object.entries(response.totalResultsPerContentGroup)
          .map(
            (entry) => `<li class="ss360-nav__menu-item ss360-tc-b" data-cgkey="cruise_lines___ships" role="none">
              <button
                data-section-id="ss360-n-section_${ss360SnakeCase(entry[0])}"
                type="button"
                class="ss360-nav__entry ss360-n-button ss360-tc-b ss360-ac-bg--hover ss360-tc-c ss360-ac-b--hover ss360-nav__entry--first"
                role="menuitem"
              >
                ${entry[0] === '_' ? 'Other' : entry[0]}<span class="ss360-nav__result-count">${entry[1]}</span>
              </button>
            </li>`
          )
          .join('')
      );

      $('#ss360-suggest-results').html(
        `<h2 id="ss360-search-result-heading" class="ss360-layer__heading">${response.totalResults} search results for "${response.query}"</h2>
          ${Object.entries(response.suggests)
            .map(
              (entry) => `<section id="ss360-n-section_${ss360SnakeCase(entry[0])}" class="ss360-n-section ss360-group">
                <h3 class="ss360-group__heading ss360-tc-bg">${entry[0] === '_' ? 'Other' : entry[0]}</h3>
                <ul class="ss360-list">${getSs360ListItems(entry[1], response.query)}</ul>
                ${response.totalResultsPerContentGroup[entry[0]] > entry[1].length
                    ? `<button
                        type="button"
                        class="ss360-more-results ss360-n-button ss360-ac-c ss360-ac-b ss360-ac-bg--hover"
                        data-query="${response.query}"
                        data-offset="5"
                        data-group="${entry[0]}"
                        data-total=${response.totalResultsPerContentGroup[entry[0]]}
                        >Show More Results</button>`
                    : ''
                  }
              </section>`
            )
            .join('')}`
      ).scrollTop(0);
    }
  });
};

const getSs360ListItems = (suggests, searchQuery) => {
  return suggests
    .map(
      (suggest) => {
        const regEx = new RegExp(`\\b${searchQuery}\\b`, 'ig');
        const title = suggest.name.replace(regEx, (str) => `<span class="ss360-highlight">${str}</span>`);
        return `<li class="ss360-suggests">
            <article class="ss360-suggests__wrap ss360-n-section" aria-labelledby="ss360-heading-24788">
              <div class="ss360-suggest__image-container">
                <a class="ss360-suggests__image-wrap" aria-hidden="true" tabindex="-1" href="${suggest.link}"
                  ><img
                    alt=""
                    aria-hidden="true"
                    role="presentation"
                    aria-label="${suggest.name}"
                    class="ss360-suggests__image"
                    src="${suggest.image}"
                /></a>
              </div>
              <div class="ss360-suggests__content">
                <header class="ss360-n-section ss360-suggests__header">
                  <span role="heading" id="ss360-heading-24788" class="ss360-suggests__link-wrap" title="${suggest.name}" aria-level="4"
                    ><a class="ss360-suggests__link ss360-ac-c" href="${suggest.link}">${title}</a></span
                  >
                </header>
                <p class="ss360-suggests__snippet">${suggest.content}</p>
              </div>
            </article>
          </li>`;
      }
    )
    .join('');
};

$(document).on('click', '.ss360-nav__entry', function () {
  const sectionId = $(this).data('sectionId');
  const parentDiv = $('#ss360-suggest-results');
  const innerListItem = $('#' + sectionId);
  parentDiv.animate(
    {
      scrollTop: parentDiv.scrollTop() + innerListItem.position().top
    },
    1000
  );
});

$(document).on('click', '.ss360-more-results', function () {
  const btn = $(this);
  const btnOriginalText = btn.text();
  btn.text('Loading...');
  const section = btn.closest('.ss360-n-section');
  const list = section.find('.ss360-list');
  const offset = btn.data('offset');
  const total = btn.data('total');
  const group = btn.data('group');
  $.ajax({
    url: 'https://global.sitesearch360.com/sites',
    type: 'GET',
    data: {
      site: 'americandiscountvacations.com',
      timeToAction: Date.now(),
      includeContent: true,
      limit: 5,
      limitPerGroup: true,
      highlightQueryTerms: true,
      offset,
      query: $(this).data('query'),
      kvtable: false,
      complexFilterFormat: true,
      sort: '_relevance',
      includeContentGroups: '["' + group + '"]'
    },
    success: function (response) {
      const items = getSs360ListItems(response.suggests[group], response.query);
      list.append(items);
      btn.text(btnOriginalText);
      if (offset >= total - 5) {
        btn.hide();
      } else {
        btn.data('offset', offset + 5);
      }
    }
  });
});

// modal search form
$('#ss360-custom-search').on('submit', function (e) {
  e.preventDefault();
  const searchValue = this.ss360CustomSearch.value;
  ss360CustomSearch(searchValue);
});

$('#ADC_ss360Form').on('submit', function (e) {
  e.preventDefault();
  $('#unibox-suggest-box').removeClass('unibox--active');
  const searchValue = this.siteSearch.value;
  $('#ss360-custom-searchbox').val(searchValue);
  openSs360Modal();
  $('#ss360-custom-search').trigger('submit');
});

$('#ss360CloseLayerButton').on('click', function () {
  closeSs360Modal();
});

$(document).on('click', '.ss360-modal-body-wrapper', function () {
  closeSs360Modal();
});

let ss360SearchBoxTimeout = null;
$('#ss360SearchBox').on('keyup', function (e) {
  const inputValue = $(this).val();
  clearTimeout(ss360SearchBoxTimeout);
  if (inputValue.length === 0) {
    populatePopularSearches();
    return;
  }
  if (e.key === 'Enter' || inputValue.length < 2) {
    $('#unibox-suggest-box').removeClass('unibox--active');
    return;
  }
  ss360SearchBoxTimeout = setTimeout(() => ss360ExecuteSearch(inputValue), 500);
});

$('#ss360SearchBox').on('focus', function () {
  const inputValue = $(this).val();
  if (inputValue.length > 0) {
    ss360ExecuteSearch(inputValue);
    return;
  }
  populatePopularSearches();
});

$('#ss360SearchBox').on('blur', function () {
  if ($('#unibox-suggest-box').is(':hover')) {
    return;
  }
  $('#unibox-suggest-box').removeClass('unibox--active');
});

// hide search section if clicked outside of it
$(document).on('click', function (e) {
  const searchBtn = $('#app_search_button');
  const container = $('#search_drop');
  const mobileSearch = $('#search');
  const notBtn = !searchBtn.is(e.target) && searchBtn.has(e.target).length === 0;
  const notContainer = !container.is(e.target) && container.has(e.target).length === 0;
  const noMobileSearch = !mobileSearch.is(e.target) && mobileSearch.has(e.target).length === 0;
  if (notBtn && notContainer && noMobileSearch) {
    container.slideUp();
  }
});
